const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/how-to',
    translationKey: dummy_t('footer.serviceAccess'),
  },
  {
    path: '/terms-of-service',
    translationKey: dummy_t('footer.tos'),
  },
  {
    path: '/privacy-policy',
    translationKey: dummy_t('footer.privacyPolicy'),
  },
  {
    externalPath: 'https://mamhashi.zendesk.com/hc/pl',
    translationKey: dummy_t('footer.contact'),
  },
];
